import { useState } from 'react'

import { Table as AntTable, TablePaginationConfig } from 'antd'
import { ColumnsType } from 'antd/es/table'

import Button from '../general/Button'

export type SizeType = 'small' | 'middle' | 'large' | undefined

type TableProps = {
  dataSource: object[]
  columns: ColumnsType<any>
  className?: string
  scroll?: {
    x?: number | true | string
    y?: number | string
  }
  size?: SizeType
  pagination?: false | TablePaginationConfig
  onChange?: (pagination: any, filters: any, sorter: any) => void
  loading?: boolean
  rowKey?: string
  onRow?: any
  initialDisplayedRows?: number
}

const ExpandableTable = (props: TableProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const { dataSource, initialDisplayedRows = 4 } = props

  const shouldConcatFamilyAgeAllowances = dataSource.length > initialDisplayedRows

  const firstAndLastTwoFamilyAgeAllowances = dataSource
    .slice(0, initialDisplayedRows / 2)
    .concat(dataSource.slice((-1 * initialDisplayedRows) / 2))

  return (
    <>
      <AntTable
        {...props}
        dataSource={isOpen || !shouldConcatFamilyAgeAllowances ? dataSource : firstAndLastTwoFamilyAgeAllowances}
      />
      {shouldConcatFamilyAgeAllowances && (
        <div className="w-100 flex flex__center mt-8">
          <Button
            className="flex flex__center color-green-6"
            type="link"
            onClick={() => setIsOpen((previous) => !previous)}
          >
            <div className="underline">{isOpen ? 'See less' : 'See more'}</div>
          </Button>
        </div>
      )}
    </>
  )
}

export default ExpandableTable
